export const SMART_ID_SIGN_METHOD = "smart-id"
export const MOBILE_ID_SIGN_METHOD = "mobile-id"
export const ID_CARD_SIGN_METHOD = "id-card"
export const SIMPLE_SIGN_METHOD = "simple"
export const PAYSERA_SIGN_METHOD = "paysera"

export const ID_CARD_SIGN_SESSION_STATUS_DONE = "success"
